// Mock user database stored in localStorage
const USERS_KEY = 'mock_users_db';
const CURRENT_USER_KEY = 'current_user';
const AUTH_TOKEN_KEY = 'auth_token';
const EMAIL = process.env.REACT_APP_USER_EMAIL;
const PASSWORD = process.env.REACT_APP_USER_PASSWORD;

// Initialize with a default user if no users exist
const initializeUsers = () => {
  // console.log(EMAIL)
//   const users = localStorage.getItem(USERS_KEY);
//   if (!users) {
//     const defaultUsers = [
//       {
//         id: '1',
//         name: 'MFA@150',
//         email: EMAIL,
//         password: PASSWORD,
//         createdAt: new Date().toISOString()
//       }
//     ];
//     localStorage.setItem(USERS_KEY, JSON.stringify(defaultUsers));
//   }
// };

// Get all users from localStorage
// const getUsers = () => {
//   const users = localStorage.getItem(USERS_KEY);
//   return users ? JSON.parse(users) : [];
};

// Save users to localStorage
// const saveUsers = (users) => {
//   localStorage.setItem(USERS_KEY, JSON.stringify(users));
// };

// Generate a simple token
const generateToken = (userId) => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2);
  return btoa(`${userId}:${timestamp}:${random}`);
};

// Simulate API delay
const delay = (ms = 500) => new Promise(resolve => setTimeout(resolve, ms));

// Mock Authentication Service
export const mockAuthService = {
  login: async (email, password) => {
    await delay();
    console.log(`PASSWORD IS:${PASSWORD} and password is ${password}`)
    
    initializeUsers();
    // const users = getUsers();
    
    // const user = users.find(u => u.email === email);
    
    
    // if (!user) {
    //   throw new Error('User not found');
    // }

    if (EMAIL !== email) {
      throw new Error('User not found');
    }
    
    if (PASSWORD !== password) {
      throw new Error('Invalid password');
    }
    
    const token = generateToken(1);
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    
    // const userWithoutPassword = {
    //   id: user.id,
    //   name: user.name,
    //   email: user.email,
    //   createdAt: user.createdAt
    // };
    // localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(userWithoutPassword));
    
    // return {
    //   token,
    //   user: userWithoutPassword
    // };
  },
  
  register: async (name, email, password) => {
    await delay();
    
    initializeUsers();
    // const users = getUsers();
    
    // if (users.find(u => u.email === email)) {
    //   throw new Error('User already exists with this email');
    // }
    
    // const newUser = {
    //   id: Date.now().toString(),
    //   name,
    //   email,
    //   password,
    //   createdAt: new Date().toISOString()
    // };
    
    // users.push(newUser);
    // saveUsers(users);
    
    return mockAuthService.login(email, password);
  },
  
  logout: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(CURRENT_USER_KEY);
  },
  
  getCurrentUser: () => {
    const userStr = localStorage.getItem(CURRENT_USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem(AUTH_TOKEN_KEY);
  },
  
  getToken: () => {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }
};

// Mock transaction data generator
export const mockTransactionService = {
  generateTransactions: (count = 100) => {
    const statuses = ['paid', 'pending', 'failed', 'completed'];
    const descriptions = [
      'Online Purchase',
      'Grocery Store',
      'Gas Station',
      'Restaurant',
      'Utilities Payment',
      'Subscription Service',
      'Mobile Recharge',
      'Online Transfer',
      'ATM Withdrawal',
      'Refund'
    ];
    
    const transactions = [];
    for (let i = 1; i <= count; i++) {
      const randomDays = Math.floor(Math.random() * 90);
      const date = new Date();
      date.setDate(date.getDate() - randomDays);
      
      transactions.push({
        id: `TXN${String(i).padStart(5, '0')}`,
        date: date.toISOString(),
        description: descriptions[Math.floor(Math.random() * descriptions.length)],
        amount: (Math.random() * 500 + 10).toFixed(2),
        status: statuses[Math.floor(Math.random() * statuses.length)]
      });
    }
    
    return transactions.sort((a, b) => new Date(b.date) - new Date(a.date));
  },
  
  getTransactions: async (page = 1, limit = 20, statusFilter = null) => {
    await delay(300);
    
    let allTransactions = mockTransactionService.generateTransactions();
    
    if (statusFilter) {
      allTransactions = allTransactions.filter(t => 
        t.status.toLowerCase() === statusFilter.toLowerCase()
      );
    }
    
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = allTransactions.slice(startIndex, endIndex);
    
    return {
      transactions: paginatedData,
      page,
      limit,
      total: allTransactions.length,
      totalPages: Math.ceil(allTransactions.length / limit)
    };
  }
};

export default mockAuthService;